export default __webpack_public_path__ + "static/media/before.cd5268cd.png";